import React, { Component } from 'react';
import _ from 'lodash';
import * as QuizHelpers from '../../helpers/quiz';

class Travel extends Component {
  state = {
    animate: ''
  }

  componentDidMount () {
    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Medicare Travel');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleSelectTravel (val) {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep = quiz.step + 1;

    this.props.reducer(val);
    stepMethods.setStep(nextStep);
  }

  _prevStep () {
    window.history.go(-1);
  }

  render () {
    return (
      <section className={'p30 text-center animate ' + this.state.animate}>
        <div className='wrap'>
          <h3>How often do you travel outside the area?</h3>
          <div className='radio two form'>
            <input type='radio' name='travel' value='local'
              id='local'
            /><label htmlFor='local'
              onClick={(e) => (this._handleSelectTravel(1))}>I&rsquo;m mostly local</label>
            <input type='radio' name='travel' value='away'
              id='away'
            /><label
              htmlFor='away'
              onClick={(e) => (this._handleSelectTravel(2))}>I&rsquo;m away for months at a time</label>
            <button className='btn back' onClick={this._prevStep}>Previous</button>
          </div>
        </div>
      </section>
    );
  }
}

export default Travel;



// WEBPACK FOOTER //
// ./src/components/Questions/Travel.jsx